import debounce from 'lodash/debounce';
import { useCallback } from 'react';
import { Validated } from '../../../model/general';
import { validateValue } from '../../../utils/validationUtils';

export const useDebouncedValidation = (columnsConfig: Validated<any>[],
                                       updateValidationErrors: (updater: (prevErrors: Map<string, string>) => Map<string, string>) => void,
                                       setIsEditing?: (isEditing: boolean) => void,
                                       originalData?: any,
                                       tableData?: any[]) => {
    return useCallback(
        debounce((accessor, value) => {
            setIsEditing?.(false);
            const column = columnsConfig.find((col) => col.accessor === accessor);

            validateValue(column, updateValidationErrors, accessor, value, setIsEditing, originalData, tableData);
        }, 600),
        [columnsConfig, updateValidationErrors, setIsEditing, originalData, tableData]
    );
};
